exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-area {\n  margin-bottom: 20px;\n}\n.pagination-wrap {\n  text-align: right;\n  padding: 30px 20px;\n}\n.el-table .warning-row {\n  background: oldlace;\n}\n.el-table .success-row {\n  background: #f0f9eb;\n}\n", ""]);

// exports
